<template>
  <f-container fluid class="my-5">
    <f-row class="d-flex justify-content-end">
      <f-col cols="12" sm="12" md="6" lg="3" xl="3">
        <f-headline tag="h3">{{ faarenHeadline }}</f-headline>
        <ul class="list-unstyled">
          <li v-for="item in splittedFaarenList" :key="item" class="text-success">
            <i class="fa pl-3 pr-1" :class="faarenIcon"></i>
            {{ item }}
          </li>
        </ul>
      </f-col>
      <f-col cols="12" sm="12" md="6" lg="3" xl="3">
        <f-headline tag="h3">{{ leasingHeadline }}</f-headline>
        <ul class="list-unstyled">
          <li v-for="item in splittedLeasingList" :key="item" class="text-danger">
            <i class="fa pl-3 pr-1" :class="leasingIcon"></i>
            {{ item }}
          </li>
        </ul>
      </f-col>
    </f-row>
    <f-row class="bar-comparison align-items-end d-none d-md-flex">
      <f-col cols="12" sm="12" md="12" lg="6" xl="6" class="text-center">
        <f-row>
          <f-col class="order-0 order-md-1 py-5 py-lg-0">
            <f-image :src="vehicleImage.filename" :alt="vehicleImage.alt" class="vehicle-image" fluid/>
          </f-col>
          <f-col class="order-1 order-md-0">
            <span v-html="vehicleText"></span>
          </f-col>
        </f-row>
      </f-col>
      <f-col cols="6" sm="6" md="6" lg="3" xl="3">
        <div class="comparison-bar">
          <div class="bar-left" style="height: 25rem">
            <div class="bar-content">
              <span v-html="faarenGraphContent"></span>
            </div>
          </div>
        </div>
      </f-col>
      <f-col cols="6" sm="6" md="6" lg="3" xl="3">
        <div class="comparison-bar">
          <div class="bar-right-top">
            <div class="bar-content">
              <span v-html="leasingGraphHighlightContent"></span>
            </div>
          </div>
          <div class="bar-right-bottom" style="height: 19rem">
            <div class="bar-content">
              <span v-html="leasingGraphContent"></span>
            </div>
          </div>
        </div>
      </f-col>
    </f-row>
  </f-container>
</template>

<script>
import {
  FContainer,
  FRow, FCol,
  FHeadline,
  FImage
} from "faaren-ui";


export default {
  name: "CompareGraph",
  components: {
    FContainer,
    FRow, FCol,
    FHeadline,
  },
  props: {
    faarenHeadline: String,
    faarenList: String,
    faarenIcon: String,
    faarenGraphContent: String,
    leasingHeadline: String,
    leasingList: String,
    leasingIcon: String,
    leasingGraphContent: String,
    leasingGraphHighlightContent: String,
    vehicleText: String,
    vehicleImage: Object
  },
  data() {
    return {
    }
  },
  watch: {
  },
  computed: {
    splittedFaarenList(){
      return this.faarenList.split('\n')
    },
    splittedLeasingList(){
      return this.leasingList.split('\n')
    }
  },
  methods: {
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
.comparison-bar {
  display: block;
  position: relative;
  color: white;
  text-align: center;
  padding: 2rem 1rem 0 1rem;
}
.vehicle-image {
  margin: -4.5rem 0;
}


.bar-header {
  position: relative;
  height: 7rem;
}

.bar {
  height: 13rem;
  padding: 2rem 1rem 0 1rem;
  background-image: radial-gradient(ellipse at center, #1B1B39 0, #0A0A14);

  p {
    text-align: center;
  }
}


.bar-left, .bar-right-top, .bar-right-bottom {
  width: 100%;

  h4, p {
    text-align: center;
  }
}

.bar-left {
  height: 25rem;
  background-image: radial-gradient(ellipse at center, #1B1B39 0, #0A0A14);
}

.bar-right-top{
  position: relative;
  height: 9rem;
  background: #EC0000;
}


.bar-right-bottom {
  position: relative;
  height: 12rem;
  background-image: radial-gradient(ellipse at center, #1B1B39 0, #0A0A14);
}

.bar-content {
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  .logo {
    max-width: 75%;
    margin-bottom: 1rem;
  }
}
</style>
